
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"15","height":"20","viewBox":"0 0 15 20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M13.298 0H1.764C.824 0 0 .777 0 1.698v17.166c0 .308.085.565.223.763A.861.861 0 00.935 20c.268 0 .553-.12.817-.347l5.16-4.408a.97.97 0 01.627-.215.97.97 0 01.626.216l5.143 4.407c.265.227.53.347.798.347.453 0 .894-.351.894-1.136V1.698C15 .778 14.238 0 13.298 0z","fill":"#E2E8F0"}})])
          )
        }
      }
    